module.exports = __webpack_public_path__ + "img/perrito_no_results.d2b70873.png";